// @flow

import React, { type Node } from 'react';
import styled  from 'styled-components';

import { Separator } from '../../../../commons/atoms';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { getCustomerEmail, useIncomingPayment } from '@tectonics/prs/incoming-payment';

import { OxxoNumberDisplay } from './oxxo-number';
import { OxxoBarcode } from './oxxo-barcode';
import { OxxoTipsBox } from './oxxo-tips-box';
import { SaveToPdfButton } from './save-to-pdf-button';
import { OxxoMapLink } from './oxxo-map-link';

import {
  VoucherTicket,
  VoucherTicketDueDate,
  VoucherTicketAmount,
  Title,
} from '../../commons/voucher';

export function OxxoPageContent(): Node {
  const features = useAllFeatures();
  const incomingPayment = useIncomingPayment();

  return (
    <Root data-test-id="page-pending-payment">

      <Title>
        Tu voucher OXXO fue generado.
      </Title>

      <IfFeature allFeatures={features} wanted="display_oxxo_instructions">
        <MailWarning>
          Una cópia ya fue enviada para  <strong>{getCustomerEmail(incomingPayment)}</strong>,
          sin embargo, ya puedes pagar tu compra con los seguientes datos:
        </MailWarning>
      </IfFeature>

      <VoucherTicket>

        <IfFeature allFeatures={features} wanted="display_oxxo_total_amount">
          <VoucherTicketAmount />
        </IfFeature>

        <IfFeature allFeatures={features} wanted="display_oxxo_duedate">
          <VoucherTicketDueDate />
        </IfFeature>

      </VoucherTicket>

      <Separator direction="vertical" pattern="dotted" size={5} />

      <CenterWrapper>
        <IfFeature allFeatures={features} wanted="display_oxxo_barcode">
          <OxxoBarcode />
        </IfFeature>

        <IfFeature allFeatures={features} wanted="display_oxxo_number">
          <OxxoNumberDisplay />
        </IfFeature>

        <Separator direction="vertical" size={4} />

        <IfFeature allFeatures={features} wanted="display_oxxo_payment_locations">
          <OxxoMapLink />
        </IfFeature>

        <Separator direction="vertical" size={4} />

        <IfFeature allFeatures={features} wanted="action_oxxo_save_pdf">
          <SaveToPdfButton />
        </IfFeature>
      </CenterWrapper>

      <Separator direction="vertical" pattern="dotted" size={6} />

      <IfFeature allFeatures={features} wanted="display_oxxo_tips">
        <OxxoTipsBox />
      </IfFeature>

    </Root>
  );
}

const Root = styled.div``;

const CenterWrapper = styled.div`
  @media(min-width: 990px){
    width: 70%;
    margin: auto;
  }
`;

const MailWarning = styled.p`
  margin-bottom: 16px;
  font-weight: 400;
`;
